import { render } from "./CustomerEditTicket.vue?vue&type=template&id=0bf7a2fa&scoped=true"
import script from "./CustomerEditTicket.vue?vue&type=script&lang=js"
export * from "./CustomerEditTicket.vue?vue&type=script&lang=js"

import "./CustomerEditTicket.vue?vue&type=style&index=0&id=0bf7a2fa&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\E-TICKET\\eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf7a2fa"]])

export default __exports__